//     Hudl.js v2.0.0
//     JavaScript framework for Hudl web applications
//     (c) 2015 Hudl

'use strict';
// spin up analytics, but don't expose it
var analytics = require('./analytics');
var root = require('./root').window;

module.exports = root.HudlBase = {
  Xhr: require('./xhr'),
  errorReporter: require('./error-reporter'),
  ErrorModel: require('./error-model'),
  Logger: require('./logger'),
  UsageLogEvent: require('./usage-log-event'),
  Service: require('./service'),
  _: require('./utils'),
  data: require('./data'),
  config: require('./config'),
  model: require('./model'),
  analytics: analytics
};
